import type { RunStepOut, RunStepStatus } from "../../api/types/onboardingRun";

const MARK: Record<RunStepStatus, string> = {
  pending: "·",
  running: "●",
  succeeded: "✓",
  failed: "✗",
  skipped: "–",
};

function duration(started: string | null, finished: string | null): string {
  if (!started) return "";
  if (!finished) return "running…";
  const ms = new Date(finished).getTime() - new Date(started).getTime();
  if (!Number.isFinite(ms) || ms < 0) return "";
  return `${(ms / 1000).toFixed(1)}s`;
}

export function StepsTimeline({ steps }: { steps: RunStepOut[] }) {
  if (steps.length === 0) {
    return (
      <p style={{ color: "var(--text-dim)", fontSize: "0.85rem" }}>
        No steps yet — the runner records them once the run starts.
      </p>
    );
  }
  return (
    <ol style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 4 }}>
      {steps.map((s) => (
        <li key={s.ord} style={{ fontSize: "0.85rem", display: "flex", gap: 10 }}>
          <span aria-hidden>{MARK[s.status] ?? "·"}</span>
          <span>{s.name}</span>
          <span style={{ color: "var(--text-dim)" }}>{s.status}</span>
          <span style={{ color: "var(--text-dim)" }}>{duration(s.started_at, s.finished_at)}</span>
        </li>
      ))}
    </ol>
  );
}
